import React, { useState } from 'react'
import { 
  Box,
  Checkbox,
  Collapse,
  IconButton,
  makeStyles, 
  Table, 
  TableBody, 
  TableCell, 
  TableHead, 
  TableRow,
  Typography
} from '@material-ui/core';
import IconEstado from '../../../autorizaciones/UI/IconEstado';
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons';
import { PracticaItemLaboratorio } from './PracticaItemLaboratorio';
import { AUTORIZACIONES_SOLICITUDES_ESTADOS } from '../../../../utils/constants';

const useRowStyles = makeStyles({
  root: {
    "& > *": {
      borderBottom: "unset",
    },
  },
});

const optionsfecha = {
  year: "numeric",
  month: "2-digit",
  day: "2-digit",
};

export const SolicitudesLaboratorioItem = ({item, expandirPracticas}) => {
  const classes = useRowStyles();

  const [open, setOpen] = useState(expandirPracticas);
  const [checkbox, setCheckbox] = useState(false);

  return (
    <>
      <TableRow className={classes.root}>
      <TableCell align="left">
          <Checkbox
            checked={checkbox}
            name={`solicitud-${item.idSolicitud}`}
            onChange={(e) => setCheckbox(e.target.checked)}
            disabled={item.idEstadoSolicitud !== AUTORIZACIONES_SOLICITUDES_ESTADOS.TERMINADA}            
          />
        </TableCell>
        <TableCell align="right">
          {item.urgente && (
            <IconEstado
              texto={"U"}
              useColorTable={true}
              descripcion={'Urgente'}
              extraMarginRight={true}
              backgroundColor={"red"}
            />
          )}
          <IconEstado
            useColorTable={true}
            texto={item?.estadosSolicitud?.letra}
            backgroundColor={item?.estadosSolicitud?.color}
            descripcion={item?.estadosSolicitud?.descripcion}
          />
        </TableCell>
        <TableCell align="center">
          {new Date(item.fechaPrescripcion).toLocaleString("es", optionsfecha)}
        </TableCell>
        <TableCell align="left">{item.idSolicitud}</TableCell>
        <TableCell align="left">{item.tipoSolicitud.descripcionTipo}</TableCell>
        <TableCell align="left">{item.diagnostico?.problema}</TableCell>
        <TableCell>
          {item.practicas.length > 0 && (
            <IconButton
              aria-label="expand row"
              size="small"
              onClick={() => setOpen(!open)}
            >
              {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
            </IconButton>
          )}
        </TableCell>
        <TableCell align="left">{item.afiliado?.apellido_y_nombre}</TableCell>        
      </TableRow>
      <TableRow>
        <TableCell
          style={{ paddingBottom: 0, paddingTop: 0, paddingLeft: 100 }}
          colSpan={11}
        >
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box margin={1}>
              <Typography variant="h6" gutterBottom component="div">
                Practicas
              </Typography>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    {/* <TableCell align="left"></TableCell> */}
                    <TableCell>Estado Práctica</TableCell>
                    <TableCell>Práctica</TableCell>
                    <TableCell align="right">Cantidad</TableCell>
                    <TableCell align="center">SURGE</TableCell>
                    <TableCell>Materiales</TableCell>
                    <TableCell>Institucion</TableCell>
                    {(item.conInternacion || item.idPrestacion) &&
                      <TableCell>Profesional</TableCell>
                    }
                  </TableRow>
                </TableHead>
                <TableBody>
                  {item.practicas.map((practica) => (
                    <PracticaItemLaboratorio
                      key={practica?.idCodNom?.toString()}
                      conInternacion={item.conInternacion}
                      idPrestacion={item.idPrestacion}
                      item={practica}
                      materialCotizacion={item.cotizaciones}
                      estadoSolicitud={item?.idEstadoSolicitud}
                      idTipoSolicitud={item?.idTipoSolicitud}
                      // filtros={props.filtros}
                    />
                  ))}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  )
};